/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';
import type { InitalStateInterface } from './types';

export const LAYOUT_INITIAL_STATE: InitalStateInterface = {
  showSubmenu: null,
  menuOpened: false,
  routeActive: null,
  showJson: false,

  openedAddressModal: false,
  address: undefined,
  coordinates: undefined,
  location: undefined,
  eventModalData: undefined,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState: LAYOUT_INITIAL_STATE,
  reducers: {
    setShowSubmenu(state, action) {
      state.showSubmenu = action.payload;
    },
    setMenuOpened(state, action) {
      state.menuOpened = action.payload;
    },
    setRouteActive(state, action) {
      state.routeActive = action.payload;
    },
    setShowJson(state, action) {
      state.showJson = action.payload;
    },
    showAddressModal(state, action) {
      state.openedAddressModal = true;
      state.address = action.payload.address;
      state.coordinates = action.payload.coordinates;
      state.location = action.payload.location;
    },
    closeAddressModal(state) {
      state.openedAddressModal = false;
      state.address = undefined;
      state.coordinates = undefined;
      state.location = undefined;
    },
    showEventModal(state, action) {
      state.eventModalData = action.payload;
    },
    closeEventModal(state) {
      state.eventModalData = undefined;
    },
  },
});

export const {
  setShowSubmenu,
  setMenuOpened,
  setRouteActive,
  setShowJson,
  showAddressModal,
  closeAddressModal,
  showEventModal,
  closeEventModal,
} = layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;
